import React, { FunctionComponent } from 'react';

import { connect } from 'react-redux';
import AppState from '@webapp/store/state';

import TopLocations from './top-locations';

import Box from '@components/layout/box';
import TopLocationsMap from './top-locations-map';
import styled from 'styled-components';

interface MapBoxProps {
  className?: string;
  isMobile?: boolean;
}

const mapStateToProps = (state: AppState) => ({
  isMobile: state.ui.mobile,
});

const MapBox: FunctionComponent<MapBoxProps> = ({ className, isMobile }) => {
  return (
    <Box className={className || ''} noBorderBottom>
      <TopLocationsMap className="map" />
      {!isMobile && <TopLocations className="list" />}
    </Box>
  );
};

export default connect(mapStateToProps)(styled(MapBox)`
  display: grid;
  grid-gap: 3px;

  @media ${({ theme }) => theme.device.tablet} {
    grid-template-columns: repeat(18, minmax(0, 1fr));

    .map {
      grid-column: span 11;
    }

    .list {
      grid-column: 13 / 19;
    }
  }
`);
